import { StatusCode } from './status-code';

export class ErrorResponse {
  constructor(
    errorResponse: ErrorResponse,

    public errorCode: StatusCode = null,
    public message: string = null
  ) {
    Object.assign(this, errorResponse);
  }
}
